xplenty.directive('xpHint', [
  function () {
    return {
      restrict: 'A',

      link(scope, element, attrs) {
        element.tooltip({
          placement: attrs.xpHintPlacement,
          title: attrs.xpHint,
        });
      },
    };
  },
]);
